import { useState, useEffect } from "react";
import { WifiOff, Wifi } from "lucide-react";

export default function OfflineBanner() {
  const [isOnline, setIsOnline]       = useState(navigator.onLine);
  const [showOnline, setShowOnline]   = useState(false); // brief "back online" flash

  useEffect(() => {
    const handleOffline = () => {
      setIsOnline(false);
      setShowOnline(false);
    };

    const handleOnline = () => {
      setIsOnline(true);
      setShowOnline(true);
      // Hide the "back online" confirmation after 3 seconds
      setTimeout(() => setShowOnline(false), 3000);
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online",  handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online",  handleOnline);
    };
  }, []);

  if (isOnline && !showOnline) return null;

  if (!isOnline) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="w-full bg-amber-500 text-white text-sm font-medium flex items-center justify-center gap-2 px-4 py-2"
      >
        <WifiOff className="h-4 w-4 flex-shrink-0" aria-hidden />
        You're offline — changes won't be saved until you reconnect
      </div>
    );
  }

  // Briefly show green confirmation when reconnected
  return (
    <div
      role="status"
      aria-live="polite"
      className="w-full bg-green-600 text-white text-sm font-medium flex items-center justify-center gap-2 px-4 py-2"
    >
      <Wifi className="h-4 w-4 flex-shrink-0" aria-hidden />
      You're back online
    </div>
  );
}
